import _classCallCheck from "/drone/src/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/drone/src/node_modules/@babel/runtime/helpers/esm/createClass";
import { zIndexModal } from '../../tokens';
export var OverlayManager = /*#__PURE__*/function () {
  function OverlayManager() {
    _classCallCheck(this, OverlayManager);
  }

  _createClass(OverlayManager, null, [{
    key: "pushOverlay",
    value: function pushOverlay(id, parameters) {
      var _ref = parameters || {},
          zIndex = _ref.zIndex,
          blockWindowScroll = _ref.blockWindowScroll;

      if (blockWindowScroll) {
        this.windowScrollBlocks += 1;
      }

      this.stack.push({
        id: id,
        zIndex: typeof zIndex !== 'undefined' ? zIndex : this.getTopOverlayZIndex() + 10,
        blockWindowScroll: !!blockWindowScroll
      });
    }
  }, {
    key: "removeOverlay",
    value: function removeOverlay(id) {
      var overlay = this.getOverlay(id);

      if (overlay) {
        this.stack = this.stack.filter(function (item) {
          return item.id !== id;
        });

        if (overlay.blockWindowScroll) {
          this.windowScrollBlocks -= 1;
        }
      }
    }
  }, {
    key: "getOverlay",
    value: function getOverlay(id) {
      return this.stack.find(function (item) {
        return item.id === id;
      });
    }
  }, {
    key: "getTopOverlay",
    value: function getTopOverlay() {
      return this.stack.length === 0 ? null : this.stack[this.stack.length - 1];
    }
  }, {
    key: "isTopOverlay",
    value: function isTopOverlay(id) {
      var top = this.getTopOverlay();
      return top && top.id === id;
    }
  }, {
    key: "getOverlayZIndex",
    value: function getOverlayZIndex(id) {
      var item = this.getOverlay(id);

      if (item) {
        return item.zIndex;
      }

      return zIndexModal;
    }
  }, {
    key: "hasWindowScrollBlock",
    value: function hasWindowScrollBlock() {
      return this.windowScrollBlocks > 0;
    }
  }, {
    key: "getTopOverlayZIndex",
    value: function getTopOverlayZIndex() {
      var top = this.getTopOverlay();

      if (top) {
        return top.zIndex;
      }

      return zIndexModal;
    }
  }]);

  return OverlayManager;
}();
OverlayManager.stack = [];
OverlayManager.windowScrollBlocks = 0;